import { render, staticRenderFns } from "./MasDatos.vue?vue&type=template&id=8b0431c2&scoped=true"
import script from "./MasDatos.vue?vue&type=script&lang=js"
export * from "./MasDatos.vue?vue&type=script&lang=js"
import style0 from "./MasDatos.vue?vue&type=style&index=0&id=8b0431c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0431c2",
  null
  
)

export default component.exports